import { useQuery } from '@tanstack/react-query';
import { getAxios } from '../../../../util/axios.ts';
import { ControllerRoutes } from '../../../../constants/controllerRoutes.ts';

export type PriceCalculationResult = {
  Price: number;
  DrugCost: number;
  FormCost: number;
  MarkupPercentage: number;
  DeliveryFee: number;
};

export function usePriceCalculation(
  drugFormId: number | undefined,
  strengthId: number | undefined,
  quantity: number | undefined,
  deliveryType: number | undefined,
  deliveryCity: string | undefined
) {
  // Requirements: form, strength, quantity, and delivery type must all be set
  // City is optional - if not provided for DeliverToPatient, backend assumes outside Calgary
  const isEnabled =
    drugFormId !== undefined &&
    strengthId !== undefined &&
    quantity !== undefined &&
    quantity > 0 &&
    deliveryType !== undefined;

  const query = useQuery({
    queryKey: ['priceCalculation', drugFormId, strengthId, quantity, deliveryType, deliveryCity],
    queryFn: async () => {
      const response = await getAxios().get<PriceCalculationResult>(
        ControllerRoutes.ProductListing.calculatePrice(drugFormId!, strengthId!, quantity!, deliveryType, deliveryCity)
      );
      return response.data;
    },
    enabled: isEnabled,
    staleTime: 1000 * 60 // Cache for 1 minute
  });

  return {
    price: query.data?.Price,
    deliveryFee: query.data?.DeliveryFee,
    isLoading: query.isLoading && isEnabled,
    isError: query.isError,
    priceDetails: query.data
  };
}
